import React, {} from 'react';

import { ReactComponent as CloseIcon } from 'assets/images/close-button-icon.svg';

function Contact(props) {

  function renderRemoveContactItemControl(contact) {

    if (props.disabled === true) {
      return;
    }

    if (props.canRemove(contact) === false) {
      return;
    }

    const closeButtonAttributes = {
      className: 'application-button round-button contact-profile-remove-button',
      onClick() {
        props.onRemove(contact);
      }
    };

    return <button {...closeButtonAttributes}>
      <CloseIcon />
    </button>;
  }

  function renderMain() {

    const contact = props.contact;

    const contactAttributes = {
      className: 'contact-item'
    };

    if (typeof contact === 'string') {

      contactAttributes.className += ' two-column-grid';

      return <div {...contactAttributes}>

        <span className="contact-profile-username ellipsis">{contact}</span>
        {renderRemoveContactItemControl(contact)}

      </div>;

    }

    contactAttributes.className += ' three-column-grid';

    const profilePictureURL = contact.profilePicture.url;

    const contactProfileImageAttributes = {
      src: profilePictureURL,
      className: 'contact-profile-picture'
    };

    const contactProfileImageDescription = `${contact.name} Profile Image`;

    return <div {...contactAttributes}>

      <img {...contactProfileImageAttributes} alt={contactProfileImageDescription} />
      <span className="contact-profile-username ellipsis">{contact.name} {' '}<span className="application-sub-text">({contact.value})</span></span>
      {renderRemoveContactItemControl(contact)}

    </div>;

  }

  return renderMain();

}

export default Contact;